import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgTune = function SvgTune(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M24.175 2.516l-1.98-1.98a1.249 1.249 0 00-1.87.116l-2.378 3.057a2 2 0 00-.286 1.946L12.41 10.9a.251.251 0 000 .354l1.06 1.06a.25.25 0 00.354 0l5.257-5.253c.222.082.457.124.694.124.445.001.877-.147 1.228-.421l3.058-2.377a1.25 1.25 0 00.117-1.871h-.003zM9.161 10.124a1 1 0 10-1.414 1.414l.345.344-6.131 6.13a3.307 3.307 0 00-.98 2.355 3.56 3.56 0 003.468 3.466 3.319 3.319 0 002.354-.973l6.131-6.13.465.465a1 1 0 001.414-1.414l-5.652-5.657z"
  }));
};

export default SvgTune;